import { lazy } from "react";

const UploadLeads = lazy(() => import("../Component/ManageLeads/UploadLeads"));
const InterestStatus = lazy(() => import("../Component/ManageLeads/InterestedStatus"));
const LeadsDetail = lazy(() => import("../Component/ManageLeads/LeadsDetail"));
const AssignLeads = lazy(() => import("../Component/ManageLeads/AssignLeads"));
const UnassignedLeads = lazy(() => import("../Component/ManageLeads/UnassignedLeads"));
const UNAssignC = lazy(() => import("../Component/ManageLeads/UNAssignC"));
const AssignedLeads = lazy(() => import("../Component/ManageEmployee/AssignedLeads"));
const LeadList = lazy(() => import("../Component/Leads/LeadList"));
const AddLead = lazy(() => import("../Component/Leads/AddLead"));
const CommonLeadCustomerDetail = lazy(() => import("../Component/Leads/CommonLeadCustomerDetail"));
const LeadDetails = lazy(() => import("../Component/CompleteLeadDetailPage/LeadDetails"));
const LeadWork = lazy(() => import("../Component/Leads/LeadWork"));
const Details = lazy(() => import("../Component/Leads/Details"));
const DetailsOnce = lazy(() => import("../Component/Leads/DetailsOnce"));
const DelinkingPendingRequestList = lazy(() =>
  import("../Component/DelinkFunctionality/DelinkingPendingRequestList")
);
const ProductMisMatch = lazy(() => import("../Component/Leads/ProductMisMatch"));
const CamNoteDetailsPage = lazy(() => import("../Component/Leads/CamNoteDetailsPage"));
const CibilGenerateCustomer = lazy(() => import("../Component/Leads/CibilGenerateCustomer"));
const CibilRecordList = lazy(() => import("../Component/Leads/CibilRecordList"));
const PayoutLeadDetailPage = lazy(() => import("../Component/Leads/PayoutLeadDetailPage"));
const CamNoteDetails = lazy(() => import("../Component/Leads/CamNoteDetails"));

const leadsRoutes = [
    { path: "/camnote-details", element: <CamNoteDetails />, protected: false },
  { path: "/upload-leads", element: <UploadLeads />, protected: true },
  { path: "/leads-list", element: <InterestStatus />, protected: true },
  { path: "/lead-detail/:id", element: <LeadsDetail />, protected: true },
  { path: "/reassign-leads", element: <AssignLeads />, protected: true },
  { path: "/manage-un-assigned-lead", element: <UnassignedLeads />, protected: true },
  { path: "/manage-un-assigned-lead-common", element: <UNAssignC />, protected: true },
  { path: "/manage-assigned-lead", element: <AssignedLeads />, protected: true },
  { path: "/lead-list/:stageId/:dateFilter", element: <LeadList />, protected: true },
  { path: "/add-leads", element: <AddLead />, protected: true },
  { path: "/customer-detail/:id", element: <CommonLeadCustomerDetail />, protected: true },
  { path: "/lead-details/:leadId", element: <LeadDetails />, protected: true },
  { path: "/lead-work/:id", element: <LeadWork />, protected: true },
  { path: "/add-leads-details/:id", element: <Details />, protected: false },
  { path: "/add-leads-details-once/:id", element: <DetailsOnce />, protected: false },
  {
    path: "/delinking-Pending-request-list",
    element: <DelinkingPendingRequestList />,
    protected: true,
  },
  {
    path: "/product-mismatch/:leadId/:productId",
    element: <ProductMisMatch />,
    protected: true,
  },
  { path: "/cam-note-details/:id", element: <CamNoteDetailsPage />, protected: true },
  { path: "/cibil-generate", element: <CibilGenerateCustomer />, protected: true },
  { path: "/cibil-record-list", element: <CibilRecordList />, protected: true },
  { path: "/payout-lead-detail/:id", element: <PayoutLeadDetailPage />, protected: false },
];

export default leadsRoutes;
